'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';

// -----------------------------------------------------------------------------
// The marketing cookie bar. We don't want it inside the Overwolf desktop shell,
// which embeds the store as a cross-origin iframe (see packages/ow-app).
//
// Whether we're embedded is only knowable on the client (window.self !== top),
// so we hold rendering until we know: `undefined` on the server and the first
// client paint (renders nothing — no hydration mismatch), then the script is
// added only once we've confirmed we're the top-level document. This means the
// cookie bar script never loads inside the embedded flow, rather than loading
// and being hidden after the fact.
const CookieBar = (): JSX.Element | null => {
  const [isTopLevel, setIsTopLevel] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    setIsTopLevel(window.self === window.top);
  }, []);

  if (!isTopLevel) {
    return null;
  }

  return (
    <Script
      id='cookiebar'
      src='https://www.overwolf.com/system/modules/com.overwolf.store/resources/cookiebar.min.js'
      strategy='afterInteractive'
    />
  );
};

export default CookieBar;
